import { createFileRoute } from '@tanstack/react-router';
import { useListIntegrationsSpecsQuery } from '@frontend/api-integration-dashboard';
import { IntegrationPageView } from '../../../../pages';

const DEFAULT_INTEGRATIONS_DATA = { integrationSpecs: [] };

const IntegrationPage = () => {
  const { integration } = Route.useLoaderData();
  const { data: integrationSpecsData, isLoading, isError } = useListIntegrationsSpecsQuery({ request: {} });

  const { integrationSpecs } = integrationSpecsData ?? DEFAULT_INTEGRATIONS_DATA;

  return (
    <IntegrationPageView
      integrations={integrationSpecs}
      currentIntegration={integration}
      isLoading={isLoading}
      isError={isError}
    />
  );
};

export const Route = createFileRoute('/_auth/integration/$integration')({
  component: IntegrationPage,
  loader: ({ params }) => {
    return { integration: params.integration };
  },
});
